import { render } from "./AddEditGimCustom.vue?vue&type=template&id=184f322c"
import script from "./AddEditGimCustom.vue?vue&type=script&lang=js"
export * from "./AddEditGimCustom.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__